// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__J3FyG","right":"styles_right__1cNEY"};